import TrackResponse from '@/types/TrackResponse'
import ItemType from '@/components/party/search/ItemType'
import ArtistResponse from '@/types/ArtistResponse'
import PlaylistResponse from '@/types/PlaylistResponse'
import CategoryResponse from '@/types/CategoryResponse'

export default class SearchConverter {
  static convertTrackSearchToTrack (track: any): TrackResponse {
    return {
      name: track.name,
      id: track.id,
      type: ItemType.TRACK,
      imageUrl: (track.album && track.album.images) ? track.album.images[0].url : 'default-fallback-image.png',
      artistNames: track.artists ? track.artists.map((a: any) => a.name) : ['Unkown'],
      popularity: track.popularity,
      spotifyUri: track.uri
    }
  }

  static convertSavedTrackSearchToTrack (inputTrack: SpotifyApi.SavedTrackObject): TrackResponse {
    const track = inputTrack.track
    return {
      name: track.name,
      id: track.id,
      type: ItemType.TRACK,
      imageUrl: (track.album && track.album.images) ? track.album.images[0].url : 'default-fallback-image.png',
      artistNames: track.artists ? track.artists.map((a: any) => a.name) : ['Unkown'],
      popularity: track.popularity,
      spotifyUri: track.uri
    }
  }

  static convertArtistSearchToArtist (artist: any): ArtistResponse {
    return {
      id: artist.id,
      imageUrl: (artist.images && artist.images.length > 0) ? artist.images[0].url : 'default-fallback-image.png',
      name: artist.name,
      type: ItemType.ARTIST,
      popularity: artist.popularity
    }
  }

  static convertPlaylistSearchToPlaylist (playlist: SpotifyApi.PlaylistBaseObject): PlaylistResponse {
    return {
      id: playlist.id,
      imageUrl: (playlist.images && playlist.images.length > 0) ? playlist.images[0].url : 'default-fallback-image.png',
      name: playlist.name || '',
      ownerName: playlist.owner.display_name || '',
      type: ItemType.PLAYLIST,
      uri: playlist.uri
    }
  }

  static convertArtistNamesToString (names: Array<string>): string {
    if (names.length === 1) return names[0]
    let res = ''
    for (let i = 1; i < names.length; i++) {
      res += names[i]
      if (i < names.length - 1) res += ', '
    }
    return res
  }

  static convertCategorySearchToCategory (category: SpotifyApi.CategoryObject): CategoryResponse {
    return {
      name: category.name,
      href: category.href,
      id: category.id,
      icon: category.icons[0].url
    }
  }
}
